import React, { useEffect, useState } from "react";
import { getSkills } from '../services/api/skillService';
import { FaCheck, FaPalette } from "react-icons/fa";
import CommonButton from './CommonButton';

const SkillModal = ({ selectedSkills = [], onSave, onClose }) => {
  const [skills, setSkills] = useState([]);
  const [selected, setSelected] = useState(selectedSkills);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setSelected(selectedSkills);
  }, [selectedSkills]);

  useEffect(() => {
    const loadSkills = async () => {
      try {
        const { data } = await getSkills('', 'All', 0);
        setSkills(data || []);
      } catch (err) {
        console.error("Error fetching skills:", err);
      } finally {
        setLoading(false);
      }
    };
    loadSkills();
  }, []);

  const toggleSkill = (skill) => {
    setSelected((prev) =>
      prev.some((s) => s.id === skill.id)
        ? prev.filter((s) => s.id !== skill.id)
        : [...prev, skill]
    );
  };

  const handleSave = () => {
    onSave(selected);
    onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "16px",
          padding: "24px",
          width: "480px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
        }}
      >
        <h3 style={{ marginBottom: "18px", fontWeight: "600" }}>
          Select Skills
        </h3>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <div
            style={{
              maxHeight: "300px",     
              overflowY: "auto",     
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "20px",
              paddingRight: "6px",   
            }}
          >
            {skills.map((skill) => {
              const isActive = selected.some((s) => s.id === skill.id)
              return (
                <button
                  type="button"
                  key={skill.id}
                  onClick={() => toggleSkill(skill)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "8px 14px",
                    borderRadius: "12px",
                    border: isActive
                      ? "2px solid #2563eb"
                      : "1px solid #94a3b8",
                    background: isActive ? "#eff6ff" : "#ffffff",
                    color: isActive ? "#2563eb" : "#334155",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "all 0.15s ease",
                    boxShadow: isActive
                      ? "0 0 4px rgba(37,99,235,0.3)"
                      : "none",
                  }}
                >
                  {isActive ? <FaCheck /> : <FaPalette />}
                  {skill.name}
                </button>
              );
            })}
          </div>
        )}

        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <CommonButton type="button" onClick={handleSave}>Save</CommonButton>
          <CommonButton type="button" onClick={onClose} isCancel={true}>Cancel</CommonButton>
        </div>
      </div>
    </div>
  );
};

export default SkillModal;
